import InternalToolsService from '@/services/InternalToolsService'

export const checkUIMenu = (offerSource = 'holiday-promos', isEnterprise: boolean) => {
  if (isEnterprise) {
    return { access: false, name: 'common.sidebar.holidayPromos' }
  }
  if (offerSource === 'holiday-promos') {
    //change this according to dates
    const currentDate = new Date().getTime()
    if (
      new Date('2025-11-24T16:00:00.000+00:00').getTime() <= currentDate &&
      new Date('2025-12-08T07:59:59.000+00:00').getTime() >= currentDate
    ) {
      return { access: true, name: 'common.sidebar.holidayPromos' }
    } else if (
      new Date('2025-12-29T08:00:00.000+00:00').getTime() <= currentDate &&
        new Date('2026-01-01T04:59:59.000+00:00').getTime() >= currentDate
    ) {
      return { access: true, name: 'common.sidebar.endOfYearDeals' }
    } else if (
      new Date('2026-01-01T05:00:00.000+00:00').getTime() <= currentDate &&
      new Date('2026-01-06T07:59:59.000+00:00').getTime() >= currentDate
    ) {
      return { access: true, name: 'common.sidebar.newYearDeals' }
    } else {
      return { access: false,name: 'common.sidebar.holidayPromos' }
    }
  } else {
    return { access: false, name: 'common.sidebar.holidayPromos'}
  }
}

const offersCheck = async (offerSource: string, isEnterprise: boolean) => {
  try {
    let pageType = 'custom'
    if (offerSource === 'holiday-promos') {
      //change this according to dates
      const currentDate = new Date().getTime()
      if (
        new Date('2025-11-24T16:00:00.000+00:00').getTime() <= currentDate &&
        new Date('2025-12-01T07:59:59.000+00:00').getTime() >= currentDate
      ) {
        pageType = 'black-friday'
        offerSource = 'black-friday-2025'
      } else if (
        new Date('2025-12-01T08:00:00.000+00:00').getTime() <= currentDate &&
        new Date('2025-12-08T07:59:59.000+00:00').getTime() >= currentDate
      ) {
        pageType = 'cyber-monday'
        offerSource = 'cyber-monday-2025'
      } else if (
        new Date('2025-12-22T08:00:00.000+00:00').getTime() <= currentDate &&
        new Date('2025-12-29T07:59:59.000+00:00').getTime() >= currentDate
      ) {
        pageType = 'christmas'
        offerSource = 'holiday-promotion-2025'
      } else if (
        new Date('2025-12-29T08:00:00.000+00:00').getTime() <= currentDate &&
        new Date('2026-01-06T07:59:59.000+00:00').getTime() >= currentDate
      ) {
        pageType = 'new-year'
        offerSource = 'end-of-year-offer-2025'
      }
    }

    if (isEnterprise) {
      return { access: false, offerPeriod: '', offerDetails: null, pageUrl: offerSource, pageType: pageType }
    }

    const offerDetails = await InternalToolsService.getOfferDetails({ offerUrl: offerSource })

    if (offerDetails?.customOffers.length > 0) {
      const offer = offerDetails.customOffers[0]
      const currentDate = new Date().getTime()
      const startDate = new Date(offer.startDate).getTime()
      const endDate = new Date(offer.endDate).getTime()

      if (currentDate >= startDate && currentDate <= endDate && offer.status === 'active') {
        return { access: true, offerPeriod: 'custom', offerDetails: offer, pageUrl: offerSource, pageType: pageType }
      }
    }
    return { access: false, offerPeriod: '', offerDetails: null, pageUrl: offerSource, pageType: pageType }
  } catch {
    return { access: false, offerPeriod: '', offerDetails: null, pageUrl: '', pageType: '' }
  }
}

export default offersCheck
